<template>
  <main-layout>
    <template slot="header-title">{{ $t('challenge.title') }}</template>

    <template slot="header-actions">
      <common-button
        @click="isFormOpened = true">{{ $t('challenge.actions.create') }}</common-button>
    </template>

    <template slot="main">
      <div class="container mx-auto">
        <div v-if="loading" v-loading="loading"></div>
        <div v-else-if="challenges.length > 0" class="challenges-list">
          <challenge v-for="challenge in challengesSorted" v-bind:key="challenge.id" :id="challenge.id"></challenge>
        </div>
        <empty v-else :title="$t('challenge.empty.title')" :message="$t('challenge.empty.message')">
          <a @click="isFormOpened = true">{{ $t('challenge.actions.create') }}</a>
        </empty>
        <form-challenge v-if="isFormOpened" @close="isFormOpened = false"></form-challenge>
      </div>
    </template>
  </main-layout>
</template>

<script>

import Empty from '@/components/box-entity-empty.vue'
import { mapState, mapGetters, mapActions } from 'vuex'

import Challenge from '@/components/challenge/challenge.vue'
import FormChallenge from '@/components/challenge/challenge-form.vue'

export default {
  name: 'ChallengeList',
  components: { Empty, Challenge, FormChallenge },
  data () {
    return {
      loading: true,
      isFormOpened: false
    }
  },
  computed: {
    ...mapGetters('challenges', {
      challenges: 'challenges'
    }),

    ...mapState('events', {
      events: 'items'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    challengesSorted: function () {
      return this.challenges.slice().sort(function (a, b) {
        return a.status - b.status
      })
    }
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('challenges', ['loadChallenges']),
    ...mapActions('events', ['loadEvents']),

    init () {
      if (this.site) {
        let challenges = this.loadChallenges()
        let events = this.loadEvents()

        Promise.all([challenges, events]).then(() => {
          this.loading = false
        })
      }
    }
  },

  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
  .challenges-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Challenge/ChallengeList.vue